export class ChartOfAccount {
  id: number;
  version?: number;
  chargeNumberPrefix?: string;
  accountDescription?: string;
  accountName?: string;
  lastAccountNumber?: number;
  data?: any;
  accountNumber?: number;
  taxLineDescription?: string;
  active?: boolean = true;
  subAccountNumberIncrement?: number;
  children?: ChartOfAccount[];
  orgId?: number;
  parentId?: number;
  lookupCode?: string;
  expanded?: boolean;
  hasFiscalYearLedgerAccount?: boolean;
  parent?: ChartOfAccount;
  accountTypeId?: number;
  costPoolId?: number;
  costPoolName?: string;
  expenseType?: string;
  indirectType?: string;
  categoryType?: string;
  overridable?: boolean;
  override?: boolean;
  accountTypeName?: string;
  gaapType?: string;
  universalAccount?: boolean;

  ledgerAccountId?: number;
  markForDelete?: boolean;
}

export enum ExpenseType {
  Direct = 'DIRECT',
  Indirect = 'INDIRECT',
  Unallowable = 'UNALLOWABLE'
}

export enum AccountCategoryType {
  Labor = 'LABOR',
  Materials = 'MATERIALS',
  Other = 'OTHER',
  Travel = 'TRAVEL',
  SubContractor = 'SUBCONTRACTOR'
}


export class ChartOfAccountInfo {
  id: number;
  accountNumber: string;
  accountName: string;
  accountDescription: string;

}


export class OffsetAccountMapping {
  mapping: { [id: string]: ChartOfAccountInfo; };
}


export enum LookupType {
  NotApplicable = "A000"
}

